const jpegFileType = 'image/jpeg';

const generateCanvas = (height, width) => {
  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');

  if (height && width) {
    canvas.height = height;
    canvas.width = width;
  }

  return {
    canvas,
    ctx
  };
};

const applyImageRotation = (image, rotation, width, height) => {
  const {
    canvas,
    ctx
  } = generateCanvas(height, width);
  ctx.drawImage(image, 0, 0, width, height);
  const {
    canvas: rotateCanvas,
    ctx: rotateCtx
  } = generateCanvas();
  const shouldRotate = rotation % 180 !== 0;

  if (shouldRotate) {
    rotateCanvas.width = canvas.height;
    rotateCanvas.height = canvas.width;
  } else {
    rotateCanvas.width = canvas.width;
    rotateCanvas.height = canvas.height;
  }

  rotateCtx.translate(rotateCanvas.width / 2, rotateCanvas.height / 2);
  rotateCtx.rotate(rotation * Math.PI / 180);
  rotateCtx.drawImage(canvas, -canvas.width / 2, -canvas.height / 2);
  return rotateCanvas;
};

export const rotateImage = (imageUrl, rotation) => {
  return new Promise((resolve, reject) => {
    const image = new Image();
    image.crossOrigin = 'anonymous';
    image.src = imageUrl;

    image.onload = () => {
      try {
        const rotateCanvas = applyImageRotation(image, rotation, image.width, image.height);
        rotateCanvas.toBlob(blob => {
          if (!blob) {
            reject(new Error('Failed to create blob from canvas.'));
          }

          const rotatedImageFile = new File([blob], 'image.jpeg', {
            type: jpegFileType
          });
          const rotatedImageUrl = URL.createObjectURL(rotatedImageFile);
          resolve(rotatedImageUrl);
        }, jpegFileType);
      } catch (error) {
        reject(error);
      }
    };

    image.onerror = () => reject(new Error('Failed to load image.'));
  });
};